export default __webpack_public_path__ + "static/media/heartbeat.76c60223.wav";